import HTMLTemplate from './template.html'
import './styles.scss'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling
import 'tippy.js/animations/shift-away.css'
import { ModalComponent } from '../Modal/Modal'
import User from '../../modules/user'
import Tails from '../../modules/tails'
import { cloneDeep, sortBy } from 'lodash'

export const MyFleet = (() => {
    const vueComponent = {
        data() {
            return {
                trackedAircrafts: [],
                tailsSearchInput: '',
                openSortingDropdown: false,
                sortingType: 'Tail No. Ascending',
                isLoading: true,
                userAirportCodePreference: 'ICAO'
            }
        },
        mounted() {
            this.getUserTrackedTails()
            this.startTailsObserver()
            this.subscribeToUserSettingsChanges()
        },
        created() {
            // Hide sorting dropdowns if user clicks anywhere outside
            document.body.addEventListener('click', (event) => {
                if (event.target.closest('.js-tails-sorting-toggle') === null) this.openSortingDropdown = false
            })
        },
        methods: {
            subscribeToUserSettingsChanges() {
                window.setInterval(() => this.userAirportCodePreference = User.userSettings.airportCode, 2500)
            },
            update(addedTails) {
                this.getUserTrackedTails(addedTails)
            },
            getUserTrackedTails(addedTails) {
                Tails.getModuleTails().then(tails => {
                    let talisList = cloneDeep(tails)
                    let isTrackedAircraftsDetailsUpdated = false
                    let newAddedTails = []
                    
                    if (addedTails?.length > 0) {
                        // If added tial is not already in the talisList list, then add it. On UI it will be displayed as awaiting data.
                        addedTails.forEach(tail => {
                            const isTailAlreadyAdded = talisList.find(res => res.tailNumber === tail.tailNumber)
                            if (!isTailAlreadyAdded) {
                                talisList.push({ tailNumber: tail.tailNumber, isNew: true })
                                isTrackedAircraftsDetailsUpdated = true
                            }
                        })
                    } else {
                        // Get all new tails from trackedAircrafts list. If tail is already in the talisList list, then update isNew property to false and concat the tail to the talisList list
                        // or add new tail to the talisList list again
                        newAddedTails = this.trackedAircrafts.filter(res => res.isNew)
                        if (newAddedTails.length > 0) {
                            newAddedTails.map(tail => {
                                let trackedAircraft = talisList.find(res => res.tailNumber === tail.tailNumber)
                                if (trackedAircraft) {
                                    trackedAircraft = { ...trackedAircraft, isNew: false }
                                    isTrackedAircraftsDetailsUpdated = true
                                } else {
                                    talisList.push({ tailNumber: tail.tailNumber, isNew: true })
                                }
                                return tail
                            })
                        }
                    }

                    talisList.some(tail => {
                        const trackedAircraft = this.trackedAircrafts.find(res => res.tailNumber === tail.tailNumber)
                        if (tail.status !== trackedAircraft?.status) {
                            isTrackedAircraftsDetailsUpdated = true
                            return true
                        }
                        return false
                    })
                    if (isTrackedAircraftsDetailsUpdated || this.trackedAircrafts.length !== talisList.length) {
                        // if tail is soft deleted, then add isDeleted property to the tail and set it to true
                        let updatedTails = talisList.map(tail => {
                            const trackedAircraft = this.trackedAircrafts.find(res => res.tailNumber === tail.tailNumber && res.isDeleted)
                            if (trackedAircraft) {
                                tail.isDeleted = true
                            }
                            return tail
                        })
                        this.displayAircrafts(updatedTails)
                    }
                }).finally(() => this.isLoading = false)
            },
            showAddTailModal() {
                ModalComponent.$data.showAddTailModal = true
                setTimeout(() => ModalComponent.$refs.addTailCode.focus(), 100)
            },
            showStopTrackingModal(tailInfo) {
                ModalComponent.showStopTrackingModal(tailInfo)
            },
            startTailsObserver() {
                const TWO_SECONDS = 1000 * 2
                window.setInterval(() => {
                    this.getUserTrackedTails(true)
                }, TWO_SECONDS)
            },
            displayAircrafts(tails) {
                if (this.sortingType === 'Tail No. Ascending') {
                    this.trackedAircrafts = sortBy(tails, ['tailNumber'])
                }
                if (this.sortingType === 'Tail No. Descending') {
                    this.trackedAircrafts = sortBy(tails, ['tailNumber']).reverse()
                }
                if (this.sortingType === 'Aircraft Type') {
                    this.trackedAircrafts = sortBy(tails, ['tailInfo.aircraftManufacturer'])
                }
                if (this.sortingType === 'Location') {
                    this.trackedAircrafts = sortBy(tails, ['origin'])
                }
            },
            softDeleteTail(id) {
                this.trackedAircrafts.map(res => res?.tailInfo?.id === id ? res.isDeleted = true : res)
                this.displayAircrafts(this.trackedAircrafts)
            },
        },
        watch: {
            'sortingType': function () {
                this.displayAircrafts(this.trackedAircrafts)
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-my-fleet')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})()
